import { Component, Input, OnInit } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';

@Component({
  selector: 'base-application-sections-sidebar',
  templateUrl: './base-application-sections-sidebar.component.html',
})
export class BaseApplicationSectionsSidebarComponent implements OnInit {
  @Input() sections: BaseApplicationSectionsInterface[] = [];
  @Input() areSectionsVisible: boolean = true;
  @Input({ required: true }) helpSourceUrl: string = '';
  helpSourceTab: BaseApplicationSectionsInterface;

  constructor(private offcanvasService: NgbOffcanvas) {}

  ngOnInit() {
    this.helpSourceTab = {
      id: '',
      title: 'help',
      url: this.helpSourceUrl,
      icon: 'fa-solid fa-question-circle',
      featurePermissionKeys: [],
      roleKeys: [],
    };
  }

  closeSidebar(): void {
    this.offcanvasService.dismiss();
  }

  openHelpUrl(event: Event): void {
    event.preventDefault();
    window.open(this.helpSourceUrl, '_blank');
  }
}
